/* =========================================================
   Adapter fiche produit PLAQUE DE COL (Shopify).
   - Rend la plaque live via SNPlaque (image de fond + calques texte)
   - Style propre / ancienne + zone perso (dédicace / date / chrono)
   - Taille / cadre / prix / add-to-cart (même mécanique que les affiches-carte)
   ========================================================= */
(function () {
  const SP = window.SPORTSNDECO_PLAQUE;
  if (!SP) return;

  const SIZE_LABEL  = { '30x40':'30 × 40 cm', '50x70':'50 × 70 cm', '70x100':'70 × 100 cm' };
  const FRAME_LABEL = { none:'Sans cadre', black:'Cadre noir', natural:'Cadre bois naturel' };
  const SIZES  = [{id:'30x40',label:'30 × 40 cm'},{id:'50x70',label:'50 × 70 cm'},{id:'70x100',label:'70 × 100 cm'}];
  const FRAMES = [{id:'none',label:'Sans cadre'},{id:'black',label:'Cadre noir'},{id:'natural',label:'Cadre bois naturel'}];
  const STYLE_LABEL = { propre:'Neuve (propre)', sale:'Ancienne (patinée)' };

  const state = { style:'propre', size:'50x70', frame:'none' };
  const $ = id => document.getElementById(id);
  const money = c => (c/100).toFixed(2).replace('.',',') + ' €';
  function variant(s,f){ return SP.variants.find(v => v.options.includes(SIZE_LABEL[s]) && v.options.includes(FRAME_LABEL[f])); }
  function upsellsCents(){ return (typeof window.snUpsellsTotalCents==='function') ? window.snUpsellsTotalCents() : 0; }
  function refreshPrice(){
    const v = variant(state.size, state.frame), base = v ? v.price : 0, total = base + upsellsCents();
    const pe=$('productPrice'); if(pe) pe.textContent = v ? money(base) : '—';
    ['cartPrice','snStickyPrice'].forEach(id => { const e=$(id); if(e) e.textContent = v ? money(total) : '—'; });
  }
  window.snRefreshPrice = refreshPrice;

  function opts(){
    return {
      style: state.style,
      baseHref: SP.baseUrls[state.style],
      ref: SP.data.ref,
      dedic:  $('plDedic')  ? $('plDedic').value  : '',
      date:   $('plDate')   ? $('plDate').value   : '',
      chrono: $('plChrono') ? $('plChrono').value : '',
    };
  }

  function draw(){
    if (typeof SNPlaque === 'undefined') return;
    const svg = SNPlaque.render(SP.data, opts());
    const p = $('plaquePreview'); if (p) p.innerHTML = svg;
    const pf = $('posterFrame'); if (pf) pf.dataset.frame = state.frame;
    document.querySelectorAll('.sn-frame-thumb .poster').forEach(el => { el.innerHTML = svg; });
  }
  function syncFrameThumbs(){ document.querySelectorAll('.sn-frame-thumb').forEach(t => t.classList.toggle('active', t.dataset.frame===state.frame)); }

  /* ---- style propre / ancienne ---- */
  function renderStyles(){
    const w = $('plStyles'); if(!w) return;
    w.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      state.style = b.dataset.style;
      w.querySelectorAll('button').forEach(x => x.classList.toggle('on', x===b));
      draw();
    }));
  }

  /* ---- taille / cadre ---- */
  function renderSizes(){
    const w=$('sizeOptions'); if(!w) return;
    w.innerHTML = SIZES.map(s=>{const v=variant(s.id,state.frame);
      return `<button class="size-opt ${s.id===state.size?'active':''}" data-size="${s.id}" type="button"><span class="size-label">${s.label}</span><span class="size-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.size-opt').forEach(b=>b.addEventListener('click',()=>{state.size=b.dataset.size;renderSizes();renderFrames();refreshPrice();}));
  }
  function renderFrames(){
    const w=$('frameOptions'); if(!w) return;
    w.innerHTML = FRAMES.map(f=>{const v=variant(state.size,f.id);
      return `<button class="frame-opt ${f.id===state.frame?'active':''}" data-frame="${f.id}" type="button"><span class="frame-swatch frame-swatch-${f.id}"></span><span class="frame-label">${f.label}</span><span class="frame-price">${v?money(v.price):'—'}</span></button>`;
    }).join('');
    w.querySelectorAll('.frame-opt').forEach(b=>b.addEventListener('click',()=>{state.frame=b.dataset.frame;renderSizes();renderFrames();refreshPrice();syncFrameThumbs();draw();}));
  }
  function bindMockups(){
    document.querySelectorAll('.sn-frame-thumb').forEach(t=>t.addEventListener('click',()=>{
      state.frame=t.dataset.frame; renderSizes(); renderFrames(); refreshPrice(); syncFrameThumbs(); draw();
    }));
    syncFrameThumbs();
  }

  /* ---- add to cart ---- */
  function bindCart(){
    const btn=$('addToCartBtn'); if(!btn) return;
    const buy=$('buyNowBtn'), sticky=$('snStickyAddBtn');
    if (buy) buy.addEventListener('click',e=>{e.preventDefault();window.__snBuyNow=true;btn.click();});
    if (sticky) sticky.addEventListener('click',e=>{e.preventDefault();btn.click();});
    btn.addEventListener('click', async ()=>{
      const v=variant(state.size,state.frame); if(!v){alert('Variante introuvable');return;}
      const o=opts();
      const props={ 'Style': STYLE_LABEL[state.style] };
      const dedic=(o.dedic||'').trim(), date=(o.date||'').trim(), chrono=(o.chrono||'').trim();
      if (dedic)  props['Dédicace']=dedic;
      if (date)   props['Date']=date;
      if (chrono) props['Chrono']=chrono;
      const payload={ plaque:SP.presetId, style:state.style, dedic, date, chrono, size:state.size, frame:state.frame };
      // Le worker Gelato ne peut pas re-rendre la plaque (texture image externe)
      // → upload de l'aperçu exact rasterisé (voie B hybride, fonte Oswald inlinée).
      if (window.snPrintUpload) {
        const up = await window.snPrintUpload.fromSvg(SNPlaque.render(SP.data, o),
          { fontCssUrls: [window.snPrintUpload.FONTS.oswald], size: state.size });
        if (up) { props['_print_url']=up.url; props['_print_bg']='#ffffff'; }
        else props['_print_error'] = String(window.snPrintUpload.lastError() || 'inconnu');
      }
      props['_perso']=JSON.stringify(payload);
      const items=[{ id:v.id, quantity:1, properties:props }];
      if (typeof window.snCollectUpsells==='function') { try { items.push(...window.snCollectUpsells()); } catch(e){} }
      const sp=btn.querySelector('span'); const old=sp?sp.textContent:''; btn.disabled=true; if(sp)sp.textContent='Ajout…';
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!r.ok){const e=await r.json().catch(()=>({}));throw new Error(e.description||e.message||('Erreur '+r.status));}
        if(window.__snBuyNow){window.__snBuyNow=false;window.location.href='/checkout';return;}
        document.dispatchEvent(new CustomEvent('sn:cart-added'));
      }catch(e){alert("Erreur d'ajout au panier : "+e.message);}
      finally{setTimeout(()=>{if(sp)sp.textContent=old;btn.disabled=false;},600);}
    });
  }
  function bindSticky(){
    const sticky=$('snStickyCta'), cart=$('addToCartBtn'); if(!sticky||!cart) return;
    const mob=()=>window.matchMedia('(max-width:900px)').matches;
    function up(){ if(!mob()){sticky.classList.remove('is-visible');return;}
      const r=cart.getBoundingClientRect(); const near=(innerHeight+scrollY)>(document.body.scrollHeight-200);
      sticky.classList.toggle('is-visible', r.bottom<60 && !near);
    }
    addEventListener('scroll',up,{passive:true}); addEventListener('resize',up); up();
  }

  document.addEventListener('DOMContentLoaded', () => {
    renderStyles(); renderSizes(); renderFrames(); refreshPrice(); bindCart(); bindSticky(); bindMockups();
    ['plDedic','plDate','plChrono'].forEach(id=>{ const e=$(id); if(e) e.addEventListener('input',draw); });
    draw();
  });
})();
